import React from 'react';
import styled from '@emotion/styled';
import { InfoBlock } from '../../components/InfoBlock/InfoBlock';
import { ButtonWithContentWrapper } from '../ButtonWithContentWrapper/ButtonWithContentWrapper';
import { EmotionBreakpoint } from 'dw-us-ui';

const InfoSectionWrapper = styled.div`
  .info-section-container {
    ${EmotionBreakpoint('desktop')} {
      max-width: 970px;
    }
    ${EmotionBreakpoint('tablet')} {
      max-width: 720px;
    }
    ${EmotionBreakpoint('mobile')} {
      max-width: 540px;
      .info-block-group-container {
        flex-direction: column;
      }
      .info-block-group-col {
        width: 100% !important;
      }
    }
    margin-left: auto;
    margin-right: auto;
    padding: 30px 15px 15px;
    width: 100%;
    .info-section-title {
      text-align: left;
    }
    .info-block-group-container {
      display: flex;
      flex-wrap: wrap;
    }
    .info-block-group-col {
      width: 33.333%;
      padding: 0 15px 15px 0 !important;
    }
    .info-block-header-text {
      margin-bottom: 22px;
    }
  }
`;

const InfoSection = ({ Header, infoBlocks }) => {
  const renderBlockType = fields => {
    switch (fields?.module) {
      case 'image_with_content_block': {
        return <InfoBlock fields={fields} />;
      }
      case 'button_with_content': {
        return <ButtonWithContentWrapper fields={fields} card={true} />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <InfoSectionWrapper>
      <div className="pt-5 pb-4 info-section-container">
        {Header && (
          <div className="info-block-header-text">
            <h2 className="info-section-title">{Header}</h2>
          </div>
        )}
        <div className="ml-md-0 info-block-group-container">
          {infoBlocks &&
            infoBlocks?.map((block, index) => (
              <>
                {block?.fields && (
                  <div sm={12} key={index} className="pl-md-0 pb-4 info-block-group-col">
                    {renderBlockType(block?.fields)}
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
    </InfoSectionWrapper>
  );
};

export { InfoSection };
